import { configureStore } from '@reduxjs/toolkit';
import { apiCallsReducer } from './apicalls-slice';
import { sharedStatesReducer } from './shared-state-slice';
import { userInfoReducer } from './user-info-slice';

export const store = configureStore({
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    reducer: {
        userInfo: userInfoReducer,
        apiCalls: apiCallsReducer,
        sharedStates: sharedStatesReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
